import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {getSchoolYear} from "../../../../utils/authority";
import FoodController from "../../../../services/system/food/food-controller";

class ModalEditSupplier extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            "address": "",
            "name": "",
            "nameShipper": "",
            "phone": "",
            "phoneShipper": "",
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState({showLoading: true},
                () => {
                    this.state = {
                        id: nextProps.id,
                    };
                    this.detailSupplier(nextProps.id)
                }
            )
        }
    }
    detailSupplier(typeId) {
        FoodController.detailProvider(typeId, res => {
            if (res.success) {
                this.setState(
                    res.data
                );
            } else {
                toast.error(res.message[0] =="FORBIDDEN"? "Bạn không có quyền thực hiện chức năng này!" : res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                });
            }
        });
    }
    editProvider = () => {
        if (this.state.name.length < 3){
            toast.error("Tên nhà cung cấp phải lớn hơn 3 ký tự", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (this.state.address.length < 3){
            toast.error("Địa chỉ nhà cung cấp phải lớn hơn 3 ký tự!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let payload = {
                "id": this.state.id,
                "address": this.state.address,
                "name": this.state.name,
                "nameShipper": this.state.nameShipper,
                "phone": this.state.phone,
                "phoneShipper":this.state.phoneShipper,
                yearId: parseInt(getSchoolYear()),
            }
            FoodController.editProvider(payload, res => {
                if (res.success) {
                    toast.success("Thêm nhà cung cấp thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                    this.props.onHide();
                    this.props.onRefresh()
                } else {
                    toast.error("Có lỗi xảy ra!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                }
            })
        }
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm mới nhà cung cấp</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">

                                <div className="col-12 d-flex mb-2">
                                    <label className="col-5 label-item pl-0">Tên nhà cung cấp(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        maxLength={255}
                                        type="text"
                                        placeholder="Nhập tên nhà cung cấp"
                                        className="form-control shadow-none"
                                        value={this.state.name}
                                        onChange={(event) => {
                                            this.setState({
                                                name: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-5 label-item pl-0">Địa chỉ(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        maxLength={255}
                                        type="text"
                                        placeholder="Nhập địa chỉ nhà cung cấp"
                                        className="form-control shadow-none"
                                        value={this.state.address}
                                        onChange={(event) => {
                                            this.setState({
                                                address: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-5 label-item pl-0">Điện thoại</label>
                                    <input
                                        placeholder="Nhập điện thoại"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.phone}
                                        onChange={(event) => {
                                            this.setState({
                                                phone: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-5 label-item pl-0">Người giao hàng</label>
                                    <input
                                        placeholder="Nhập tên người giao hàng"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.nameShipper}
                                        onChange={(event) => {
                                            this.setState({
                                                nameShipper: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-5 label-item pl-0">SĐT người giao hàng</label>
                                    <input
                                        placeholder="Nhập SĐT người giao hàng"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.phoneShipper}
                                        onChange={(event) => {
                                            this.setState({
                                                phoneShipper: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.editProvider()}
                                >
                                        <span className='justify-content-center'>
                                            Lưu
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Đóng
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalEditSupplier